import React from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import utilityFunctions from "@store/utilityFunctions";

const SelectOption = ({
  apiEndpoint,
  placeholder = "Select...",
  value,
  onChange,
  isMulti = false,
  isDisabled = false,
  isClearable = false,
  pageSize = 50,
  searchParam = "q",
  pageParam = "page",
  limitParam = "limit",
  labelKey = "name",
  valueKey = "id",
  additionalParams = {},
  formatLabel = null,
}) => {
  const loadOptions = async (inputValue, _, additional) => {
    const page = additional?.page || 1;
    const token = utilityFunctions.getAccessToken();

    try {
      const params = {
        [pageParam]: page.toString(),
        [limitParam]: pageSize.toString(),
        ...(inputValue && { [searchParam]: inputValue }),
        ...additionalParams,
      };

      const response = await fetch(
        `${apiEndpoint}?${new URLSearchParams(params).toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch options");
      }

      const result = await response.json();

      const options = result.results.map((item) => {
        let label;

        if (formatLabel && typeof formatLabel === "function") {
          label = formatLabel(item);
        } else if (typeof labelKey === "function") {
          label = labelKey(item);
        } else if (Array.isArray(labelKey)) {
          label = labelKey
            .map((key) => item[key])
            .filter(Boolean)
            .join(" - ");
        } else {
          label = item[labelKey];
        }

        return {
          value: item[valueKey],
          label: label,
          rawData: item,
        };
      });

      const hasMore = result.next !== null;

      return {
        options,
        hasMore,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      console.error("Error loading options:", error);
      return {
        options: [],
        hasMore: false,
      };
    }
  };

  return (
    <AsyncPaginate
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      placeholder={placeholder}
      isMulti={isMulti}
      isDisabled={isDisabled}
      isClearable={isClearable}
      additional={{
        page: 1,
      }}
      debounceTimeout={300}
      cacheUniqs={[apiEndpoint, JSON.stringify(additionalParams)]}
      key={`${apiEndpoint}-${JSON.stringify(additionalParams)}`}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: "38px",
          borderColor: "#d1d5db",
          "&:hover": {
            borderColor: "#9ca3af",
          },
        }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
};

export default SelectOption;
